module.exports = __webpack_public_path__ + "static/media/metrocorp-white-old.0142f36a.svg";